import * as React from 'react';

import {StatusBadge} from '../status-badge/status-badge';
import {Truncated} from '../truncated/truncated';

type Props = {
    materializedValue: string | null | undefined;
    required: boolean;
};

export function TemplateFieldCell(props: Props) {
    const {materializedValue, required} = props;
    if (required && !materializedValue) {
        return (
            <StatusBadge
                detail='Please add before sending'
                level='alert'
                text='Required'
                includeIcon={true}
                isInteractive={true}
            />
        );
    }

    return <Truncated title={materializedValue || undefined}>{materializedValue || ''}</Truncated>;
}
